import React from 'react';
import { Layout, message, Modal, Icon, Button } from 'antd';
import NHContainerFrame from "../../../common/NHContainerFrame/index";
import NHTable from "../../../common/NHTable/index";
import getSize from "../../../../utils/getSize";
import {hasAuth} from "../../../../utils/NHCore";  
import StudentsInfoShow from "./show";
const confirm = Modal.confirm;


const { Content } = Layout;

export default class QueryStudents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchParams: {},
            selectKey: '',
            showData: {}, //修改的数据
            showAdd: false,
            showListPage: true,
            show: false,
            isAdd: true,
            showOperationBtn: false,
        }
    }

    //搜索框条件值改变时调用的方法
    inputChange = (param) => {
        let searchParams = this.state.searchParams;
        let name = param.target.name;
        searchParams[name] = param.target.value;
        this.setState({
            searchParams: searchParams
        });
    }
    //查询操作
    onSearch = (e) => {
        this.refs.nhTable.filterTableData();
    }

    //查看详情
    show = () => {
        let params = {};
        let row = this.refs.nhTable.state.selectedRows;
        if (row && row.length > 0) {
            if (row.length > 1) {
                confirm({
                    title: ' 选择了多条记录，将对第一条记录进行查看，确定这么做么?',
                    onOk: () => {
                        this.setState({ show: true, showData: row[0], showListPage: false });
                    },
                    onCancel: () => { }
                });
            } else {
                this.setState({ show: true, showData: row[0], showListPage: false });
            }
        } else {
            message.warning('请选择列表中的一条数据');
        }
    }

    exportClickListener = (tar) => {
        tar.exportExcel('学生信息查询');
    };

    render() {
        let columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '70',
                cacheFixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '100',
                search: 'input',
                searchType:"select"
            }, {
                title: '学院名称',
                dataIndex: 'BMMC',
                width: '200',
                search: 'input',
                searchType:"select"
            }, {
                title: '专业名称',
                dataIndex: 'ZYMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级名称',
                dataIndex: 'BJMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180',
                search: 'input',
                searchType:"input"
            }, {
                title: '学生类别',
                dataIndex: 'XSLB',
                width: '120',
                search: 'input',
                searchType:"select"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                width: '150',
                search: 'input',
                searchType:"input"
            }, {
                title: '生源地',
                dataIndex: 'SSQMC',
                width: '180',
                search: 'input',
                searchType:"input"
            } ,{
                title: '手机号码',
                dataIndex: 'SJHM',
                width: '120',
                search: 'input',
                searchType:"input"
            }, {
                title: '是否缴费',
                dataIndex: 'SFJF',
                width: '120',
                search: 'input',
                filters: [{ text: '是', value: '是' }, { text: '否', value: '否' }],
                searchType:"select"
            },{
                title: '缴费情况',
                dataIndex: 'JFQK',
                width: '120',
                search: 'input',
                searchType:"input"
            },{
                title: '是否人脸识别',
                dataIndex: 'SFRLSB',
                width: '130',
                search: 'input',
                searchType:"input"
            },
            {
                title: '报到类型',
                dataIndex: 'BDQK',
                width: '120',
                search: 'input',
                searchType:"input"
            },{
                title: '报到时间',
                dataIndex: 'BDSJ',
                width: '120'
            },{
                title: '紧急联系人',
                dataIndex: 'JJLXR',
                width: '120',
                search: 'input',
                searchType:"input"
            },{
                title: '联系人电话',
                dataIndex: 'LXRDH',
                width: '120',
                search: 'input',
                searchType:"input"
            },{
                title: '是否报到',
                dataIndex: 'SFBD',
                width: '120',
                search: 'input',
                cacheFixed: 'right',
                filters: [{ text: '是', value: '是' }, { text: '否', value: '否' }],
                searchType:"select"
                // cacheFixed: 'right',
                // render: (value) => {
                //     return value == '是' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                //         : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>;
                // }
            }
        ];
        return (
            <div>
                <Layout style={{ height: '100%' }}>
                    {this.state.showListPage == true && <Layout>
                        <Layout >
                            <Content style={{ margin: '12px', marginBottom: '0px', padding: '12px', background: '#fff', minHeight: 280, height: getSize().windowH - 123 }}>
                                <div style={{ width: '100%', height: '97%', }}>
                                   <NHTable
                                        ref='nhTable'
                                        rowKey={record => record.XSID}
                                        sign={"zhxg_yxxt_newStudentInfo_queryPage_gzykdx"}
                                        columns={columns}
                                        initParams={this.state.searchParams}
                                        rowSelectionChange={this.rowSelectionChange}
                                        rangeFilter={true}>
                                        {hasAuth("zhxg_yxgl_tjcx_xsxxcx:export") &&
                                        <Button type="primary" ghost onClick={() => this.exportClickListener(this.refs.nhTable)}
                                                style={{marginLeft: 10}}>导出</Button>}
                                    </NHTable>
                                </div>
                            </Content>
                        </Layout>
                    </Layout>}
                </Layout >
                <NHContainerFrame style={{ margin: '12px 12px 0 12px', padding: '16px', background: '#fff' }} title={"学生详情"} visible={this.state.show} footer={[]} onCancel={() => { this.setState({ show: false, showListPage: true }) }} >
                    <StudentsInfoShow ref={(form) => { this.showForm = form }} showData={this.state.showData} />
                </NHContainerFrame>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/gyQueryStudents/index.js